import '@inbox-demo-nx/theme';

import { RowStack, Spacer } from '@inbox-demo-nx/ui';
import Button from '@inbox-demo-nx/ui-button';
import { Text, useSx } from 'dripsy';
import { useEffect, useState } from 'react';
import { Linking, ViewStyle } from 'react-native';

import StatusBarIcons from './statusbar-icons.svg';

const timeFormat = new Intl.DateTimeFormat('en', {
  timeStyle: 'short',
  hourCycle: 'h23',
});

export default function StatusBar({
  variant,
  style,
}: {
  variant: 'dark' | 'light';
  style?: ViewStyle;
}) {
  const sx = useSx();
  const [time, setTime] = useState(timeFormat.format());
  useEffect(() => {
    const setIntervalId = setInterval(() => {
      setTime(timeFormat.format());
    }, 1000);

    return () => {
      clearInterval(setIntervalId);
    };
  }, []);
  const contentColor = variant === 'dark' ? 'black' : 'white';
  const isInIframe = window.parent !== window.self;

  return (
    <RowStack
      style={[
        sx({ height: 44, backgroundColor: 'navigationHeaderBackground' }),
        style,
      ]}
    >
      <Text sx={{ ml: 20, fontWeight: '500', color: contentColor }}>
        {time}
      </Text>
      <Spacer size="stretch" />
      {isInIframe ? (
        <StatusBarIcons style={{ marginRight: 14 }} fill={contentColor} />
      ) : (
        <Button
          title="Talk to sales"
          rounded
          size="small"
          style={{ marginRight: 12 }}
          onPress={() => {
            Linking.openURL('https://sendbird.com/contact-sales');
          }}
        />
      )}
    </RowStack>
  );
}
